import { render } from "./SellingBuyingCallouts.vue?vue&type=template&id=32cb2938&scoped=true"
const script = {}

import "./SellingBuyingCallouts.vue?vue&type=style&index=0&id=32cb2938&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cb2938"]])

export default __exports__